import { Core } from "@faire/design-tokens";
import { useChatAuthorization } from "@faire/help-center-self-serve/chat/hooks/useChatAuthorization";
import { isLocaleChatSupported } from "@faire/help-center-self-serve/utils/isLocaleChatSupported";
import { browserLevelLocaleKey } from "@faire/help-center-utils/serialized-data/getLocale";
import { getSettingSelfServeShowAllLanguage } from "@faire/help-center-utils/settings/getSettingSelfServeShowAllLanguage";
import { ChatBubble } from "@faire/web/slate/icons/foundation/ChatBubble";
import { LoadingSpinner } from "@faire/web/slate/LoadingSpinner";
import { Spacer } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import styled from "styled-components";
import { ContactUsOptionsWrapper } from "../../components/ContactUsOptionsWrapper";
import { ColumnWrapper, LeftMarginWrapper } from "../../components/EmailUs";
import { IconWrapper } from "../../components/IconWrapper";
import { OperatingTime } from "../../components/OperatingTime";
import { FormattedAvailableTime } from "./FormattedAvailableTime";
var ChatBtnCopy = function ChatBtnCopy(_ref) {
  var textColor = _ref.textColor;
  if (!getSettingSelfServeShowAllLanguage() || isLocaleChatSupported(browserLevelLocaleKey())) {
    return /*#__PURE__*/React.createElement(Typography, {
      variant: "paragraphSansMedium",
      color: textColor
    }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "fomA9v",
      defaultMessage: [{
        "type": 0,
        "value": "Chat live"
      }]
    }));
  }
  return /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraphSansMedium",
    color: textColor
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "mOJrcC",
    defaultMessage: [{
      "type": 0,
      "value": "Live chat in English"
    }]
  }));
};
export var DesktopChat = function DesktopChat(_ref2) {
  var onClick = _ref2.onClick,
    _ref2$disableChat = _ref2.disableChat,
    disableChat = _ref2$disableChat === void 0 ? false : _ref2$disableChat,
    _ref2$loading = _ref2.loading,
    loading = _ref2$loading === void 0 ? false : _ref2$loading;
  var _useChatAuthorization = useChatAuthorization(),
    chatBtnEnabled = _useChatAuthorization.chatBtnEnabled;
  var textColor = chatBtnEnabled && !disableChat ? Core.text["default"] : Core.text.subdued;
  if (disableChat) {
    return /*#__PURE__*/React.createElement(ContactUsOptionsWrapper, {
      onClick: onClick,
      disabled: true,
      dataTestId: "chat-disable-btn"
    }, /*#__PURE__*/React.createElement(ColumnWrapper, null, /*#__PURE__*/React.createElement(IconWrapper, {
      disabled: true
    }, /*#__PURE__*/React.createElement(ChatBubble, {
      fontSize: "24"
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Spacer, {
      height: "1/2x"
    }), /*#__PURE__*/React.createElement(LeftMarginWrapper, null, /*#__PURE__*/React.createElement(ChatBtnCopy, {
      textColor: textColor
    }), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, {
      variant: "labelSansRegular",
      color: textColor
    }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "sBpYL4",
      defaultMessage: [{
        "type": 0,
        "value": "Live chat is currently unavailable due to site maintenance."
      }]
    })))));
  }
  if (loading) {
    return /*#__PURE__*/React.createElement(LoadingWrapper, null, /*#__PURE__*/React.createElement(LoadingSpinner, null));
  }
  return /*#__PURE__*/React.createElement(ContactUsOptionsWrapper, {
    onClick: onClick,
    disabled: !chatBtnEnabled || loading,
    dataTestId: "chat-btn"
  }, /*#__PURE__*/React.createElement(ColumnWrapper, null, /*#__PURE__*/React.createElement(IconWrapper, {
    disabled: !chatBtnEnabled
  }, /*#__PURE__*/React.createElement(ChatBubble, {
    fontSize: "24"
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Spacer, {
    height: "1/2x"
  }), /*#__PURE__*/React.createElement(LeftMarginWrapper, null, /*#__PURE__*/React.createElement(ChatBtnCopy, {
    textColor: textColor
  }), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), chatBtnEnabled ? ( /*#__PURE__*/React.createElement(Typography, {
    color: textColor
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "W2Hkec",
    defaultMessage: [{
      "type": 0,
      "value": "Average wait: 3 minutes"
    }]
  }))) : ( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(OperatingTime, {
    color: textColor,
    supportType: "chat"
  }), /*#__PURE__*/React.createElement(FormattedAvailableTime, {
    supportType: "chat",
    color: textColor
  }))))));
};
var LoadingWrapper = styled(ContactUsOptionsWrapper).withConfig({
  displayName: "DesktopChat__LoadingWrapper"
})(["justify-content:center;", "{min-width:270px;}", "{min-width:150px;}", "{min-width:150px;}", "{min-width:270px;}"], responsiveMediaQueries.mobile, responsiveMediaQueries.tablet, responsiveMediaQueries.desktop, responsiveMediaQueries.xLargeAndAbove);